<div class="page-content page-fill">
  @if (peopleAdmin) {
    <div class="card mb-3">
      <div class="card-body d-flex flex-row">
        @if (filter) {
          <dx-form [formData]="filter" style="max-width: 200px">
            <dxi-item dataField="startDate" editorType="dxDateBox" [label]="{ text: 'Start' }"></dxi-item>
            <dxi-item dataField="endDate" editorType="dxDateBox" [label]="{ text: 'End' }"></dxi-item>
          </dx-form>
        }
        <div class="flex-column">
          <button class="btn btn-primary print-button" (click)="printMemberCalendar()" [hidden]="!canPrintCalendar">Print Member Calendar</button>
          <button class="btn btn-success print-button" (click)="printMemberInfo()" [hidden]="!canPrintMemberSheets">Print Member Info Sheets</button>
        </div>
      </div>
    </div>
  }

  <div class="grid-fill">
    <dx-data-grid
      #familiesGrid
      [dataSource]="families"
      keyExpr="id"
      [focusedRowEnabled]="true"
      [wordWrapEnabled]="true"
      [rowAlternationEnabled]="false"
      (onToolbarPreparing)="onToolbarPreparing($event)"
      (onCellDblClick)="rowDoubleClick($event)"
      >
      <dxi-column dataField="name" [width]="250" [sortIndex]="1" [sortOrder]="'asc'"></dxi-column>
      <dxi-column dataField="displayAddress" caption="Address" [width]="400"></dxi-column>
      <dxi-column dataField="household.name" caption="Household" [width]="400"></dxi-column>
      <dxi-column dataField="created" format="shortDateShortTime" width="200px"></dxi-column>
      <dxi-column dataField="includeInDirectory" width="200px"></dxi-column>

      <dxo-sorting mode="multiple"></dxo-sorting>
      <dxo-filter-row [visible]="true"></dxo-filter-row>
      <dxo-remote-operations [sorting]="true" [filtering]="true"></dxo-remote-operations>
      <dxo-selection mode="{{ appInfo.graafschap ? 'multiple' : 'none' }}"></dxo-selection>
      <dxo-state-storing [enabled]="true" type="sessionStorage" storageKey="familiesGrid"></dxo-state-storing>
      <dxo-search-panel [visible]="true"></dxo-search-panel>

      <div *dxTemplate="let data of 'toolbarButtons'">
        @if (peopleAdmin) {
          <dx-button text="Add" type="default" (onClick)="addOpen()"></dx-button>
        }
        @if (peopleAdmin) {
          <dx-button text="Open" type="primary" (onClick)="addOpen(familiesGrid.focusedRowKey)"></dx-button>
        }
        @if (peopleAdmin) {
          <dx-button
            class="ms-4"
            text="Assign Household(s)"
            type="primary"
            (onClick)="assignHousehold(familiesGrid.instance.getSelectedRowsData())"
          ></dx-button>
        }
      </div>
      <div *dxTemplate="let data of 'toolbarText'">
        @if (families) {
          <span class="me-3">
            <strong>{{ familiesGrid.instance.totalCount() + ' families' }}</strong>
          </span>
        }
      </div>
    </dx-data-grid>
  </div>
</div>
